import React from "react";
import { ProductConsumer } from "../../Context/AddProWakel";
import { STATUS_OPTIONS } from "./orderStatus";

const FILTER_OPTIONS = [{ value: "", label: "هەموو دۆخەکان" }, ...STATUS_OPTIONS];

const FillDetailOrders = () => (
    <ProductConsumer>
        {(value) => {
            const {
                OR_status,
                OR_page,
                OR_pages,
                OR_total,
                OR_applyFilter,
                OR_pageplusone,
                OR_pageminsone,
                AddProChange,
            } = value;

            return (
                <div className="rs-toolbar">
                    <h5 className="rs-toolbar__title">
                        <i className="fas fa-shopping-cart"></i>
                        داواکارییەکانی ئۆنڵاین
                    </h5>

                    <span className="rs-toolbar__sep" />

                    <div className="rs-field">
                        <label className="rs-field__label" htmlFor="OR_status">
                            دۆخ
                        </label>
                        <select
                            id="OR_status"
                            name="OR_status"
                            value={OR_status}
                            onChange={AddProChange}
                            className="rs-select"
                        >
                            {FILTER_OPTIONS.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    <button className="rs-btn rs-btn--primary" onClick={OR_applyFilter}>
                        <i className="fas fa-search"></i>
                        بگەڕە
                    </button>

                    <div className="rs-pager">
                        <span className="rs-pager__count">
                            کۆی داواکارییەکان: <span className="rs-num">{OR_total}</span>
                        </span>
                        <button
                            className="rs-btn rs-btn--ghost rs-btn--icon"
                            onClick={OR_pageminsone}
                            disabled={OR_page <= 1}
                            title="پێشوو"
                        >
                            <i className="fas fa-chevron-right"></i>
                        </button>
                        <span className="rs-pager__pos rs-num">
                            {OR_page} / {OR_pages}
                        </span>
                        <button
                            className="rs-btn rs-btn--ghost rs-btn--icon"
                            onClick={OR_pageplusone}
                            disabled={OR_page >= OR_pages}
                            title="دواتر"
                        >
                            <i className="fas fa-chevron-left"></i>
                        </button>
                    </div>
                </div>
            );
        }}
    </ProductConsumer>
);

export default FillDetailOrders;
